var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-menu"},[_c('ul',_vm._l((_vm.sidebarMenu),function(menuItem){return _c('li',{key:menuItem.id},[_c('a',{attrs:{"href":menuItem.linkURL}},[_vm._v(_vm._s(menuItem.linkText))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }